// extracted by mini-css-extract-plugin
module.exports = {"figure":"SmallFigure--figure--2ZgUV","background":"SmallFigure--background--3Fcdj"};